export default __webpack_public_path__ + "portfolio08.jpg";